import api from './axios';

export const listNotifications         = (params = {}) => api.get('/notifications', { params });
export const markNotificationSeen      = (id)          => api.post(`/notifications/${id}/seen`);
export const markAllNotificationsSeen  = ()            => api.post('/notifications/seen-all');
